import { cloneDeep } from 'lodash';
import { useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Col, Row } from 'reactstrap';
import { setLoading } from '../../store/slices/auth';
import { CustomButton, showToaster, toasterTypes } from '../../widgets';
import { FieldItem } from '../../widgets/fields';
import useFieldItem from '../../widgets/fields/UseFieldItem';
import ModalComponent from '../common/Modal/modal';
import { getProjectTeamList } from '../people/apiController';
import { createForm, updateForm, getRoles, getUsers, getFormTemplates, getFormUsageTypes } from './apiController';
import { CreateFormElements } from './FormElements';
import { DeleteFilled } from '@ant-design/icons';
import { languagesData } from '../common/utils/languagesData';
import { uploadPhoto } from '../profile/apiController';

export default function CreateForm(props) {
	const dispatch = useDispatch();
	const initialValues = useMemo(() => (
		props.previousState ?
			props.previousState :
			{ name: '', description: '', type: null, group: null, surveyType: { label: "No", value: false }, startdate: null, enddate: null, form_usage_type: [], tags: [], parent_tag: '', is_localized: false, translate: false, custom_return_message: "", place_holder: "", custom_color_logic: "", dssd: false, dssd_number: 1 }
	), [props.previousState]);
	const [values, fields, handleChange, { validateValues, updateValue }] = useFieldItem(CreateFormElements, initialValues, { onValueChange });
	const [permissions, setpermissions] = useState([{ id: 1, role: null, users: [], user: '', accessType: [] }]);
	const [roles, setroles] = useState<any | []>([]);
	const [formTemplates, setFormTemplates] = useState<any>([]);
	const [formUsageTypes, setFormUsageTypes] = useState<any>([]);
	const [isLocalized, setisLocalized] = useState(false);
	const [localizationData, setLocalizationData] = useState<any>([{ language: null, localized_value: "" }]);
	const [action, setAction] = useState("");

	useEffect(() => {
		fetchRoles(0);
		fetchTemplates();
		fetchFormUsageTypes();
		if (props.isEdit) {
			let tempType = CreateFormElements.type.values.filter((obj) => obj.value === props.formData?.form_type);
			//Convert the array of form usage types into {label:"",value:""} key value pairs and then assign it to form_usage_type
			const convertedFormUsageArray = props.formData?.form_use_category?.map(item => ({ label: item, value: item })) || [];
			let tempSurveyType = props.formData?.survey_form ? CreateFormElements.surveyType.values[0] : CreateFormElements.surveyType.values[1];
			updateValue({ group: { label: props.group.label, value: props.group.value }, name: props.formData?.form_name, description: props.formData?.form_desc, type: tempType[0], surveyType: tempSurveyType, startdate: props.formData?.start_date, enddate: props.formData?.end_date, form_usage_type: convertedFormUsageArray ? convertedFormUsageArray : [], tags: props.formData?.tags || [], parent_tag: props.formData?.parent_tag || '', is_localized: props.formData?.is_localized ? true : false, translate: props.formData?.translate ? true : false, custom_return_message: props.formData?.custom_return_message, place_holder: props.formData?.place_holder, custom_color_logic: props.formData?.custom_color_logic, banner_image: props.formData?.banner_image, dssd: props.formData?.dssd || false, dssd_number: props.formData?.dssd_number || 1 });

			const getLanguageObject = (value) => {
				return languagesData.find(lang => lang.value === value) || null;
			};

			let localizedData = props.formData?.localized || [];

			const transformedData = localizedData.length > 0
				? localizedData.map(item => ({
					language: item.language ? getLanguageObject(item.language) : null,
					localized_value: item.localized_value || ""
				}))
				: [{ language: null, localized_value: "" }];

			setLocalizationData(transformedData);
		} else {
			updateValue({ group: { label: props.group.label, value: props.group.value } })
		}
		console.log(props)
	}, []);

	/**
	 * fetch Form Usage Types and update the state
	 * 
	 */
	const fetchFormUsageTypes = async () => {
		try {
			dispatch(setLoading(true));
			let formUsageTypesResponse = await getFormUsageTypes();
			//convert the array to key value pairs of {label:"",value:""}
			const convertedArray = formUsageTypesResponse?.form_usage_types?.map(item => ({ label: item, value: item })) || [];
			setFormUsageTypes(convertedArray || []);
			dispatch(setLoading(false));
		} catch (error) {
			dispatch(setLoading(false));
		}
	}

	/**
	 * fetch form templates and update the state
	 * 
	 */
	const fetchTemplates = async () => {
		try {
			dispatch(setLoading(true));
			let tempTemplates = await getFormTemplates("JAF");
			tempTemplates.data.map(item => {
				setFormTemplates(prevState => [...prevState, { label: item.templatename, value: item.ref_id }])
			})
			dispatch(setLoading(false));
		} catch (error) {
			dispatch(setLoading(false));
		}
	}

	/**
	 * list of roles
	 * @param index 
	 */
	const fetchRoles = async (index) => {
		try {
			dispatch(setLoading(true));
			let tempRoles = await getRoles();
			if (tempRoles && tempRoles.data && tempRoles.data.length > 0) {
				tempRoles.data.forEach((obj, index) => {
					obj.label = obj.name;
					obj.value = obj.name.toLowerCase();
					obj.index = index;
					obj.users = [];
				});
				if (props.isEdit) {
					let temp: any = [];

					// Process role access first
					if (props.formData?.form_role_access) {
						props.formData.form_role_access.forEach((roleObj) => {
							let tempPermissions = tempRoles.data.filter((obj) => obj.value === roleObj.role_name);
							const accessTypeValue = roleObj.permissions.filter(item => item.is_selected == true).map(permissionItem => {
								return permissionItem.title == "read" ? "r" : permissionItem.title == "write" ? "w" : "f";
							});
							temp.push({ id: temp.length + 1, role: tempPermissions[0], users: [], user: '', accessType: accessTypeValue[0] });
						});
					}

					// Process user access
					if (props.formData?.form_user_access && props.formData.form_user_access.length > 0) {
						// Use Promise.all to handle async operations properly
						const userPromises = props.formData.form_user_access.map(async (userObj, userIndex) => {
							let tempPermissions = tempRoles.data.filter((obj) => obj.value === userObj.role_name);
							userObj.label = userObj.email;

							if (userObj.role_name == "field-executive") {
								userObj.value = userObj.user_number || userObj.imei;
							} else {
								userObj.value = userObj.user_number || userObj.invitee_id;
							}

							let roleIndex = tempRoles?.data.findIndex((obj) => obj.value === userObj.role_name);
							let userList = [];

							if (roleIndex >= 0) {
								try {
									let projectid = { projectid: props.projectData.id };
									let tempUsers = await getProjectTeamList(projectid, 1, 100, "", "accepted", userObj.role_name);

									if (tempUsers?.data && tempUsers.data.length > 0) {
										tempUsers.data.forEach((obj) => {
											obj.label = obj.emailid;
											obj.value = obj.usernumber;
										});
										tempRoles.data[roleIndex].users = tempUsers.data;
										userList = tempUsers.data;
									}
								} catch (e) {
									console.error("Error fetching users:", e);
								}
							}

							const accessTypeValue = userObj.permissions.filter(item => item.is_selected == true).map(permissionItem => {
								return permissionItem.title == "read" ? "r" : permissionItem.title == "write" ? "w" : "f";
							});

							return {
								id: temp.length + userIndex + 2, // +2 to account for role access items
								role: tempPermissions[0],
								users: userList,
								user: userObj,
								accessType: accessTypeValue[0]
							};
						});

						const userResults = await Promise.all(userPromises);
						temp.push(...userResults);
					}

					// Only add empty item if no data exists
					if (temp.length === 0) {
						temp = [{ id: 1, role: null, users: [], user: '', accessType: [] }];
					}
					setpermissions(temp); // Don't spread with prev, replace entirely
					setroles(tempRoles.data);
				} else {
					if (tempRoles?.data && tempRoles.data.length > 0) {
						let tempPermissions = cloneDeep(permissions);
						tempPermissions[index] = { id: 1, role: null, users: [], user: '', accessType: [] };
						fetchUsers(tempRoles.data, 0, tempPermissions, index);
					}
				}
			}
			dispatch(setLoading(false));
		} catch (e) {
			console.error("Error in fetchRoles:", e);
			setroles([]);
			dispatch(setLoading(false));
		}
	};

	const fetchUsers = async (roleData, roleIndex, tempPermissions, perIndex) => {
		if (roleData[roleIndex].users.length === 0) {
			try {
				dispatch(setLoading(true));
				console.log(props.projectData.id);
				let projectid: any = { projectid: props.projectData.id };
				//let tempUsers = await getUsers(props.projectData.TopicCode || props.projectData.TopicID, roleData[roleIndex].label.toLowerCase());
				let tempUsers = await getProjectTeamList(projectid, 1, 100, "", "accepted", roleData[roleIndex].label.toLowerCase());

				if (tempUsers?.users && tempUsers.users.length > 0) {
					tempUsers.users.forEach((obj) => {
						obj.label = obj.invitee_name;
						if (obj.invitee_role == "field-executive") {
							obj.value = obj.imei;
						} else {
							obj.value = obj.invitee_id;
						}
					});

					console.log(perIndex, tempPermissions)

					roleData[roleIndex].users = tempUsers.users;
					tempPermissions[perIndex].users = tempUsers.users;

				}

				if (tempPermissions.length === 0) {
					tempPermissions = [{ id: 1, role: null, users: [], user: '', accessType: [] }];
				}
				console.log(tempPermissions)
				setpermissions(tempPermissions);
				setroles(roleData);
				dispatch(setLoading(false));
			} catch (e: any) {
				setroles(roleData);
				if (tempPermissions.length === 0) {
					tempPermissions = [{ id: 1, role: null, users: [], user: '', accessType: [] }];
				}
				setpermissions(tempPermissions);
				dispatch(setLoading(false));
			}
		} else {
			tempPermissions[perIndex].users = roleData[roleIndex].users;
			setroles(roleData);
			if (tempPermissions.length === 0) {
				tempPermissions = [{ id: 1, role: null, users: [], user: '', accessType: [] }];
			}
			setpermissions(tempPermissions);
		}
	}


	/**
	 * 
	 * @param name 
	 * @param value 
	 * @param values 
	 * @param fieldValues 
	 * @returns 
	 */
	function onValueChange(name, value, values, fieldValues = null) {
		let resetValue = {};
		console.log(values)
		//console.log(formTemplates)

		return [{
			...values,
			...resetValue,
			[name]: value,
		}]
	}

	function changePermissions(name, value, indexId) {
		let temp: any = cloneDeep(permissions);

		console.log(temp)
		// console.log("$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$")

		if (name === 'role' && value) {
			temp[indexId]['user'] = null;
			temp[indexId].users = [];
			temp[indexId][name] = value;
			fetchUsers(roles, value.index, temp, indexId); //commented time being
		} else if (name === 'user' && value) {
			let isUser = false;
			for (var i = 0; i < temp.length; i++) {
				//console.log(temp)
				console.log("-----------------------------------");
				let obj = temp[i]
				if (obj.user && (obj.user.invitee_id == value.invitee_id || (value.invitee_id && obj.user?.user_number == value.invitee_id) || obj.user?.imei == value.imei)) {
					// console.log("*************")
					// console.log(value)
					console.log("$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$");
					// console.log(obj.user)
					// console.log("*************")
					continue;
				} else {
					console.log("inside else loop");
					temp[indexId][name] = value;
				}

			}


			// temp.forEach((obj) => {
			// 	// console.log(obj.user)
			// 	// console.log("*************")
			// 	// console.log(value)

			// 	if (obj.user && (obj.user.invitee_id == value.invitee_id || obj.user?.user_number == value.invitee_id || obj.user?.imei == value.imei)) {

			// 		console.log(value)
			// 		console.log(obj.user)
			// 		console.log("*************")
			// 		isUser = true;
			// 		// showToaster(toasterTypes.ERROR, 'User is already added');
			// 		return;
			// 	}
			// });


			// if (isUser) {
			// 	// showToaster(toasterTypes.ERROR, 'User is already added');
			// } else {
			// 	temp[index][name] = value;
			// }
			console.log(temp)
			setpermissions(temp);
		} else if (name == 'accessType') {
			temp[indexId][name] = value;
			setpermissions(temp);
		}
	}

	/**
	 * remove permission from array
	 */
	const removePermission = (id) => {
		console.log(id)
		setpermissions(permissions.filter(item => item.id != id))
	}

	/**
	 * change localization data
	 * @param name 
	 * @param value 
	 * @param index 
	 */
	function changeLanguage(name, value, index) {
		if (index >= 0) {
			let tempLanguages = cloneDeep(localizationData);
			tempLanguages[index][name] = value;
			setLocalizationData(tempLanguages);
		}
	}

	/**
	 * add language to localizationData array
	 */
	const addLanguage = () => {
		let tempLanguage = cloneDeep(localizationData);
		tempLanguage.push({ language: null, localized_value: "" });
		setLocalizationData(tempLanguage);
	}

	const uploadDoc = async (data, resolve, reject) => {
		try {
			dispatch(setLoading(true));
			let response = await uploadPhoto(data);
			if (response.mediaUrl) {
				resolve(response.mediaUrl);
			}
			dispatch(setLoading(false));
		} catch (e: any) {
			reject('');
			dispatch(setLoading(false));
		}
	}

	/**
	 * on save 
	 * submit details to create form
	 */
	const onSave = async () => {
		console.log(values)
		if (isLocalized) {
			if (validateValues(["is_localized"])) {
				showToaster(toasterTypes.ERROR, "Please enter the proper values in the fields highlighted in red");
				return;
			} else {
				let tempLanguage = localizationData.filter((obj) => obj.language && obj.localized_value);
				if (tempLanguage.length === 0) {
					showToaster(toasterTypes.ERROR, "Please add proper localization values");
					return;
				} else {
					setLocalizationData(tempLanguage);
					setisLocalized(false);
				}
			}
		}
		else if (validateValues(["name", "description", "type", "group", "surveyType"])) {
			showToaster(toasterTypes.ERROR, "Please enter the proper values in the fields highlighted in red");
		} else {
			let form_role_access: any = [];
			let form_user_access: any = [];
			permissions.forEach((obj: any) => {
				if (obj.user && obj.user.value && obj.user.label && (obj.user.invitee_role || obj.user.role_name) && obj.accessType && obj.accessType.length > 0) {
					console.log(obj)
					form_user_access.push({
						"user_id": obj.user.invitee_id || obj.user.user_number,
						"user_number": obj.user.invitee_id || obj.user.user_number,
						"email": obj.user.label,
						"role_name": obj.user.invitee_role || obj.user.role_name,
						"imei": obj.user.invitee_role == "field-executive" || obj.user.role_name == "field-executive" ? obj.user.imei : "",
						"permissions": [
							{
								"title": "read",
								"permission": "read",
								"is_selected": obj.accessType == "r" ? true : false
							},
							{
								"title": "write",
								"permission": "write",
								"is_selected": obj.accessType == "w" ? true : false
							},
							{
								"title": "forbidden",
								"permission": "forbidden",
								"is_selected": obj.accessType == "f" ? true : false
							}
						]
					});
				} else if (obj.role?.value && obj.accessType && obj.accessType.length > 0) {
					form_role_access.push({
						"role_name": obj.role.value,
						"permissions": [
							{
								"title": "read",
								"permission": "read",
								"is_selected": obj.accessType == "r" ? true : false
							},
							{
								"title": "write",
								"permission": "write",
								"is_selected": obj.accessType == "w" ? true : false
							},
							{
								"title": "forbidden",
								"permission": "forbidden",
								"is_selected": obj.accessType == "f" ? true : false
							}
						]
					});
				}
			});
			// Remove duplicate roles from form_role_access based on role_name
			const filteredFormRoleAccess = form_role_access
				.filter(item => item.role_name && item.permissions && item.permissions.length > 0)
				.filter((item, index, self) =>
					index === self.findIndex(t => t.role_name === item.role_name)
				);
			// convert form_usage_type to array
			const convertedFormUsageArray = values.form_usage_type.map(item => item.value) || [];

			let tempLocalizationData: any = localizationData.map(item => ({
				language: item.language?.value || null,
				localized_value: item.localized_value || ""
			}));

			let uploadedBannerImage;
			const uploadFormData = new FormData();
			uploadFormData.append('file', values.banner_image && values.banner_image[0]);
			values.banner_image && await new Promise((resolve, reject) => {
				uploadDoc(uploadFormData, resolve, reject);
			}).then((result: any) => {
				uploadedBannerImage = result;
			}).catch(error => {
				uploadedBannerImage = error;
			});

			let reqObj: any = {
				"topicid": props.projectData?.TopicID || props.projectData?.TopicCode,
				"form_name": values.name,
				"form_desc": values.description,
				"tags": values.tags,
				"parent_tag": values.parent_tag,
				"form_type": values.type.value,
				"form_group_id": values.group.value,
				"form_group": values.group.label,
				"survey_form": values.surveyType.value,
				"strict_mode": props.projectData?.strict_mode,
				"start_date": values.startdate,
				"end_date": values.enddate,
				"form_use_category": convertedFormUsageArray, //Send the form usage types as an array
				"form_template_id": values.formTemplate?.value,
				form_role_access: filteredFormRoleAccess,
				form_user_access,
				is_localized: values.is_localized,
				translate: values.translate,
				localized: tempLocalizationData,
				custom_return_message: values.custom_return_message,
				place_holder: values.place_holder,
				custom_color_logic: values.custom_color_logic,
				banner_image: uploadedBannerImage,
				dssd: values.dssd || false,
				dssd_number: Number(values.dssd_number) || 1
			}
			if (props.isEdit) {
				reqObj.id = props.formData?.id
			}
			console.log(reqObj)
			try {
				dispatch(setLoading(true));
				let response: any;
				console.log(reqObj)
				if (props.isEdit) {
					response = await updateForm(reqObj);
				} else {
					response = await createForm(reqObj);
				}
				dispatch(setLoading(false));
				showToaster(toasterTypes.SUCCESS, response.message);
				props.onFormCreation();
			} catch (e: any) {
				dispatch(setLoading(false));
			}
		}
	}

	const addUser = () => {
		let temp: any = cloneDeep(permissions);
		temp.push({ id: temp[temp.length - 1].id + 1, role: null, users: [], user: '', accessType: [] });
		setpermissions(temp);
	}

	return (
		<>
			{action === "customColorFormulaPopup" &&
				<ModalComponent
					width="600px"
					isOpen={true}
					onClose={() => setAction("")}
					header={"Custom color logic"}
					centered={true}
					customClass='score-formula-popup-modal'
					body={
						<>
							<p>
								You can use <b>color tags</b> and <b>ternary expressions</b> to style parts of your message.
							</p>

							<h4 className="text-sm font-semibold mt-2">Color Tags</h4>
							<p>
								- Use <code>{`<color:blue>Your text</color>`}</code> for fixed colors. <br />
								- Use <code>{`<custom_color>Your text</custom_color>`}</code> to apply color based on your custom color logic.
							</p>

							<h4 className="text-sm font-semibold mt-3">Custom Color Logic</h4>
							<p>
								A <b>ternary expression</b> is a concise way to apply conditional colors, similar to an if-else.
							</p>

							<code>condition ? value_if_true : value_if_false</code>

							<p className="mt-2">
								Example:
								<br />
								<code>
									{`(score < 20) ? 'green' :
(score < 30 or (score > 60 and score < 70)) ? 'orange' :
(score > 30) ? 'blue' :
'gray'`}
								</code>
							</p>

							<p className="mt-2">
								Use logical keywords <b>and</b> / <b>or</b> and color names or HEX codes (e.g. <code>'#00FF00'</code>).
							</p>
						</>
					}

					footer={<></>}
				/>
			}
			<ModalComponent
				width={window.innerWidth > 700 ? "1200px" : "350px"}
				isOpen={true}
				onClose={() => isLocalized ? setisLocalized(false) : props.onClose()}
				header={isLocalized ? "Localization" : props.isEdit ? "Edit Form" : "Create Form"}
				centered={true}
				customClass='profile-modal form-modal'
				body={
					isLocalized ?
						<>
							<div className='localization-container'>
								<div className='localization'>Localization</div>
								{localizationData.map((obj, index) => (
									<Row key={index}>
										<Col md={4}>
											<FieldItem
												{...CreateFormElements.language}
												value={obj.language}
												onChange={(...e) => changeLanguage(CreateFormElements.language.name, ...e, index)}
											/>
										</Col>
										<Col md={4}>
											<FieldItem
												{...CreateFormElements.localized_value}
												value={obj.localized_value}
												onChange={(...e) => changeLanguage(CreateFormElements.localized_value.name, ...e, index)}
											/>
										</Col>
									</Row>
								))}
								<div className='add-text text-center' onClick={() => addLanguage()}>Add More</div>
							</div>
						</>
						:
						<>
							<div>
								<Row>
									<Col md={8}>
										<FieldItem
											{...CreateFormElements.name}
											value={values.name}
											onChange={(...e) => handleChange(CreateFormElements.name.name, ...e)}
											touched={fields.name && fields.name.hasError}
											error={fields.name && fields.name.errorMsg}
										// isDisabled={props.isEdit}
										/>
									</Col>

								</Row>
								<Row>
									<Col md={7}>
											<FieldItem
												{...CreateFormElements.description}
												value={values.description}
												onChange={(...e) => handleChange(CreateFormElements.description.name, ...e)}
												touched={fields.description && fields.description.hasError}
												error={fields.description && fields.description.errorMsg}
											/>
											<FieldItem
												{...CreateFormElements.parent_tag}
												value={values.parent_tag}
												onChange={(...e) => handleChange(CreateFormElements.parent_tag.name, ...e)}
												touched={fields.parent_tag && fields.parent_tag.hasError}
												error={fields.parent_tag && fields.parent_tag.errorMsg}
											/>
									</Col>
									<Col md={4}>
										<FieldItem
											{...CreateFormElements.tags}
											value={values.tags}
											onChange={(...e) => handleChange(CreateFormElements.tags.name, ...e)}
											touched={fields.tags && fields.tags.hasError}
											error={fields.tags && fields.tags.errorMsg}
										/>
									</Col>
								</Row>
								<Row>
									<Col md={4} className='custom-size'>
										<FieldItem
											{...CreateFormElements.type}
											value={values.type}
											onChange={(...e) => handleChange(CreateFormElements.type.name, ...e)}
											touched={fields.type && fields.type.hasError}
											error={fields.type && fields.type.errorMsg}
										/>
									</Col>
									<Col md={4}>
										<FieldItem
											{...CreateFormElements.group}
											value={values.group}
											values={props.groups}
											onChange={(...e) => handleChange(CreateFormElements.group.name, ...e)}
											touched={fields.group && fields.group.hasError}
											error={fields.group && fields.group.errorMsg}
										/>
									</Col>
									<Col md={4}>
										<FieldItem
											{...CreateFormElements.surveyType}
											value={values.surveyType}
											onChange={(...e) => handleChange(CreateFormElements.surveyType.name, ...e)}
											touched={fields.surveyType && fields.surveyType.hasError}
											error={fields.surveyType && fields.surveyType.errorMsg}
										/>
									</Col>

									<Col md={3}>
										<FieldItem
											{...CreateFormElements.form_usage_type}
											value={values.form_usage_type}
											values={formUsageTypes}
											onChange={(...e) => handleChange(CreateFormElements.form_usage_type.name, ...e)}
											touched={fields.form_usage_type && fields.form_usage_type.hasError}
											error={fields.form_usage_type && fields.form_usage_type.errorMsg}
										/>
									</Col>

									<Col md={3}>
										<FieldItem
											{...CreateFormElements.startdate}
											value={values.startdate}
											onChange={(...e) => handleChange(CreateFormElements.startdate.name, ...e)}
											touched={fields.startdate && fields.startdate.hasError}
											error={fields.startdate && fields.startdate.errorMsg}
										/>
									</Col>
									<Col md={3}>
										<FieldItem
											{...CreateFormElements.enddate}
											value={values.enddate}
											onChange={(...e) => handleChange(CreateFormElements.enddate.name, ...e)}
											touched={fields.enddate && fields.enddate.hasError}
											error={fields.enddate && fields.enddate.errorMsg}
										/>
									</Col>
									<Col md={3}>
										<FieldItem
											{...CreateFormElements.formTemplate}
											value={values.formTemplate}
											values={formTemplates && formTemplates}
											onChange={(...e) => handleChange(CreateFormElements.formTemplate.name, ...e)}
											touched={fields.formTemplate && fields.formTemplate.hasError}
											error={fields.formTemplate && fields.formTemplate.errorMsg}
										/>
									</Col>
									{/* <Col md={2}>
							<FieldItem
								{...CreateFormElements.strictmode}
								value={values.strict_mode}
								onChange={(...e) => handleChange(CreateFormElements.strictmode.name, ...e)}
								touched={fields.strictmode && fields.strictmode.hasError}
								error={fields.strictmode && fields.strictmode.errorMsg}
							/>
						</Col> */}
								</Row>
								<div className='localization-option'>
									<div className='head-text'>Localization</div>
									<Row>
										<Col md={4}>
											<FieldItem
												{...CreateFormElements.is_localized}
												value={values.is_localized}
												onChange={(...e) => handleChange(CreateFormElements.is_localized.name, ...e)}
												touched={fields.is_localized && fields.is_localized.hasError}
												error={fields.is_localized && fields.is_localized.errorMsg}
											/>
										</Col>
										{values.is_localized &&
											<Col md={8} className='text-right'>
												<div className='user-text' onClick={() => setisLocalized(true)}>View/Add Language</div>
											</Col>
										}
									</Row>
								</div>
								<div className='translation-option'>
									<div className='head-text'>Translation</div>
									<Row>
										<Col md={4}>
											<FieldItem
												{...CreateFormElements.translate}
												value={values.translate}
												onChange={(...e) => handleChange(CreateFormElements.translate.name, ...e)}
												touched={fields.translate && fields.translate.hasError}
												error={fields.translate && fields.translate.errorMsg}
											/>
										</Col>
									</Row>
								</div>
								<div className='dis-allow-survey-form-submit'>
									{/* <div className='head-text'>DSSD</div> */}
									<Row>
										<Col md={4}>
											<FieldItem
												{...CreateFormElements.dssd}
												value={values.dssd}
												onChange={(...e) => handleChange(CreateFormElements.dssd.name, ...e)}
												touched={fields.dssd && fields.dssd.hasError}
												error={fields.dssd && fields.dssd.errorMsg}
											/>
										</Col>
										{values.dssd && <Col md={4}>
											<FieldItem
												{...CreateFormElements.dssd_number}
												value={values.dssd_number}
												onChange={(...e) => handleChange(CreateFormElements.dssd_number.name, ...e)}
												touched={fields.dssd_number && fields.dssd_number.hasError}
												error={fields.dssd_number && fields.dssd_number.errorMsg}
											/>
										</Col>}
									</Row>
								</div>
								<div className='custom_result'>
									<div className='head-text'>Custom Result</div>
									<Row>
										<Col md={8}>
											<FieldItem
												{...CreateFormElements.custom_return_message}
												value={values.custom_return_message}
												onChange={(...e) => handleChange(CreateFormElements.custom_return_message.name, ...e)}
												touched={fields.custom_return_message && fields.custom_return_message.hasError}
												error={fields.custom_return_message && fields.custom_return_message.errorMsg}
											/>
										</Col>
										<Col md={4}>
											<FieldItem
												{...CreateFormElements.place_holder}
												value={values.place_holder}
												onChange={(...e) => handleChange(CreateFormElements.place_holder.name, ...e)}
												touched={fields.place_holder && fields.place_holder.hasError}
												error={fields.place_holder && fields.place_holder.errorMsg}
											/>
										</Col>
									</Row>
									<Row>
										<Col md={8}>
											<FieldItem
												{...CreateFormElements.custom_color_logic}
												value={values.custom_color_logic}
												onChange={(...e) => handleChange(CreateFormElements.custom_color_logic.name, ...e)}
												touched={fields.custom_color_logic && fields.custom_color_logic.hasError}
												error={fields.custom_color_logic && fields.custom_color_logic.errorMsg}
											/>
											<p
												className='custom-color-formula-note'>Use the Ternary Expression. <span onClick={() => {
													setAction("customColorFormulaPopup")
												}}>Learn More</span></p>
										</Col>
									</Row>
								</div>
								<div className='upload-banner'>
									<div className='head-text'>Upload Banner Image</div>
									<Row>
										<Col md={8}>
											<FieldItem
												{...CreateFormElements.banner_image}
												value={values.banner_image}
												onChange={(...e) => handleChange(CreateFormElements.banner_image.name, ...e)}
												touched={fields.banner_image && fields.banner_image.hasError}
												error={fields.banner_image && fields.banner_image.errorMsg}
											/>
										</Col>
									</Row>
									{values.banner_image && <p className='uploaded-image-text'>Uploaded Image : <span>{typeof (values.banner_image) === "string" ? values.banner_image : values.banner_image[0]?.name}</span></p>}
								</div>
								<div className='permissions-border'>
									<Row className='m-0'>
										<Col className='p-0'>
											<div className='permissions-text'>Permissions</div>
										</Col>
										<Col className='p-0'>
											<div className='user-text' onClick={() => addUser()}>Add User</div>
										</Col>
									</Row>
								</div>

								{roles.length > 0 && (
									permissions.map((obj: any, index) => (
										console.log(obj),
										<Row className='m-0 permissions-row' key={index}>
											<Col md="3">
												<FieldItem
													{...CreateFormElements.role}
													value={obj.role}
													values={roles}
													onChange={(...e) => changePermissions(CreateFormElements.role.name, ...e, index)}
												/>
											</Col>
											<Col md="4">
												<FieldItem
													{...CreateFormElements.user}
													value={obj.user}
													values={obj.users}
													onChange={(...e) => changePermissions(CreateFormElements.user.name, ...e, index)}
												/>
											</Col>
											<Col md="4">
												<FieldItem
													{...CreateFormElements.accessType}
													value={obj.accessType}
													onChange={(...e) => changePermissions(CreateFormElements.accessType.name, ...e, index)}
												/>
											</Col>
											<Col md="1">
												{permissions.length > 1 ?
													<DeleteFilled style={{ color: 'red' }} onClick={() => removePermission(obj.id)} />
													:
													""
												}
											</Col>
										</Row>
									)
									))}
							</div>
						</>
				}
				footer={
					<div>
						<CustomButton type="primary" isDisabled={false} text="Save" onClick={() => onSave()}></CustomButton>
					</div>
				}
			/>
		</>
	)
}
